'use client';
import './deleteDialog.scss';
import React from 'react';
import CloseIcon from '@mui/icons-material/Close';
/* eslint-disable @next/next/no-img-element */
import { Button, Dialog, DialogContent, DialogTitle, IconButton, Typography } from '@mui/material';
import { useShoppingCart } from '@/context/ShoppingCartContext';
import { MixpanelEvent } from '@/services/eventEnums';
import { MixpanelTracking } from '@/services/mixpanel';
import { useTranslation } from 'react-i18next';
import { DeleteDialogProps } from '../cartInterfaces';

export default function DeleteDialog({ itemId }: DeleteDialogProps): React.ReactElement {
  const { t } = useTranslation('cart');
  const { removeFromCart } = useShoppingCart();
  const [open, setOpen] = React.useState<boolean>(false);

  const handleClickOpen = (): void => {
    setOpen(true);
  };

  const handleClose = (): void => {
    setOpen(false);
  };

  const deleteItem = (id: string | number): void => {
    removeFromCart(id);
    MixpanelTracking.getInstance().track(MixpanelEvent.CART_ITEM_DELETE, {
      item_id: id,
    });
    handleClose();
  };

  return (
    <>
      <IconButton
        size="small"
        onClick={handleClickOpen}
        name="Delete Item"
        aria-label="delete-cart-item-btn"
      >
        <i className="icon-delete"></i>
      </IconButton>

      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="skywatch-dialog delete-dialog"
      >
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
          {t('deleteTitle')}
        </DialogTitle>
        <IconButton
          name="Close Delete Item"
          aria-label="close-delete-item-dialog"
          className="close-btn"
          onClick={handleClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 15,
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent>
          <Typography variant="body1">{t('deleteDesc')}</Typography>

          <Button
            size="large"
            fullWidth
            variant="outlined"
            color="secondary"
            onClick={() => deleteItem(itemId)}
            name="yes-delete-button"
          >
            {t('yesDelete')}
          </Button>
          <Button
            size="large"
            fullWidth
            variant="contained"
            onClick={handleClose}
            name="no-delete-button"
          >
            {t('noDelete')}
          </Button>
        </DialogContent>
      </Dialog>
    </>
  );
}
